export default __webpack_public_path__ + "static/media/piny-logo-mor.fd8856c2.png";